export default __webpack_public_path__ + "static/media/bp.b00245aa.png";